export class PostGetProviderQuickSearchRequest {
    language?: string;
    age?: number;
    gender?: string;
    maxDisplayCount?: number;
}

export class PostGetLocationQuickSearchRequest {
    language?: string;
    age?: number;
    gender?: string;
    maxDisplayCount?: number;
}